var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgMailIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.857v9.74a1.53 1.53 0 0 0 1.526 1.526h18.948A1.53 1.53 0 0 0 22 13.597V3.97l-11.08 7.396L0 3.857z",
    fill: "#C62032"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.47 0H1.527C.688 0 0 .688 0 1.53v.474L10.932 9.52l11.065-7.387v-.604A1.53 1.53 0 0 0 20.471 0z",
    fill: "#C62032"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMailIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/mailIcon.81fce36d.svg";
export { ForwardRef as ReactComponent };